// extracted by mini-css-extract-plugin
module.exports = {"detailHeader":"detail-header_detailHeader___JG3f","paragraph":"detail-header_paragraph__RwXAa","maxLines":"detail-header_maxLines__zPp6y"};